import {
  GET_USER_JOURNALS,
  PATCH_USER_JOURNALS,
  CREATE_USER_JOURNALS,
  DELETE_USER_JOURNALS
} from '../constants/journals';

export default (state = [], action) => {
  switch (action.type) {
    case PATCH_USER_JOURNALS:
      let newStatePatch = [...state];
      newStatePatch = newStatePatch.map((journal) => {
        if (journal.id === action.payload.journal) {
          journal.data = action.payload;
        }
        return journal;
      });

      return newStatePatch;
    case GET_USER_JOURNALS:
      return action.payload;
    case DELETE_USER_JOURNALS:
      let newStateDelete = [...state];
      newStateDelete = newStateDelete.map((journal) => {
        if (journal.data && journal.data.id === action.payload) {
          delete journal.data;
        }
        return journal;
      });

      return newStateDelete;

    case CREATE_USER_JOURNALS:
      let newStateCreate = [...state];
      newStateCreate = newStateCreate.map((journal) => {
        if (journal.id === action.payload.journal) {
          journal.data = action.payload;
        }
        return journal;
      });

      return newStateCreate;
    default:
      return state;
  }
};
